import "sitecss/home.css";
//import * as qtipval from "./jquery.qtip.validation";
//import * as toastr from "toastr";
//import * as util from "./site";
////Object.assign(window, qtipval);
////qTipValInit();

//util.messageBoxOk("hello","hey, here's a message");